import {
  GenericInfoPopup,
  Icon,
  IconName,
  getAgentErrorSubtitle,
  getAgentErrorTitle,
  useDeviceTypes,
} from "halifax";
import React, { useContext, useState } from "react";
import { RouteComponentProps } from "react-router";
import {
  ErrorType,
  MODAL_ALERT,
  MODAL_ALERT_CHOICE,
  ModalAlertProperties,
  ModalButtonType,
  ModalCategoryType,
  ModalScreens,
} from "redmond";

import { ClientContext } from "../../../../App";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { PATH_HOME } from "../../../../utils/paths";
import { AvailabilityErrorModalConnectorProps } from "./container";
import "./styles.scss";
import * as textConstants from "./textConstants";
import { SEARCH_AGAIN, GO_BACK } from "../../../common/textConstants";

export interface IAvailabilityErrorModalProps
  extends AvailabilityErrorModalConnectorProps,
    RouteComponentProps {}

export const AvailabilityErrorModal = (props: IAvailabilityErrorModalProps) => {
  const { hasFailed, history, fetchInitialExperiencesAvailability } = props;
  const { isAgentPortal } = useContext(ClientContext);
  const { matchesMobile } = useDeviceTypes();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const modalEventProperties: ModalAlertProperties = {
    lob: "experiences",
    type: "experiences_availabiltity_error",
    primary_button: SEARCH_AGAIN,
    secondary_button: GO_BACK,
    screen: ModalScreens.EXPERIENCES_AVAILABILITY,
    category: ModalCategoryType.TROUBLE,
    modal_subtitle: textConstants.AVAILABILITY_ERROR_SUBTITLE,
    modal_title: textConstants.AVAILABILITY_ERROR_TITLE,
    agent_title: getAgentErrorTitle(ErrorType.NoAvailability),
    agent_subtitle: getAgentErrorSubtitle(ErrorType.NoAvailability),
    funnel: "experiences",
    step: "availability",
  };
  React.useEffect(() => {
    if (hasFailed) {
      setIsOpen(true);
      trackEvent({
        eventName: MODAL_ALERT,
        properties: { ...modalEventProperties },
      });
    }
  }, [hasFailed]);

  const buttons = [
    {
      buttonText: GO_BACK,
      buttonWrapperClassName: "availability-error-modal-button",
      onClick: () => {
        setIsOpen(false);
        trackEvent({
          eventName: MODAL_ALERT_CHOICE,
          properties: {
            ...modalEventProperties,
            button_choice: ModalButtonType.SECONDARY,
          },
        });

        history.push(PATH_HOME);
      },
    },
    {
      buttonText: SEARCH_AGAIN,
      buttonWrapperClassName: "availability-error-modal-button",
      defaultStyle: "h4r-secondary",
      onClick: () => {
        setIsOpen(false);
        trackEvent({
          eventName: MODAL_ALERT_CHOICE,
          properties: {
            ...modalEventProperties,
            button_choice: ModalButtonType.PRIMARY,
          },
        });
        fetchInitialExperiencesAvailability(history);
      },
    },
  ];

  return (
    <GenericInfoPopup
      agentSubtitle={getAgentErrorSubtitle(ErrorType.NoAvailability)}
      agentTitle={getAgentErrorTitle(ErrorType.NoAvailability)}
      buttons={buttons}
      className="experiences-availability-error-modal-root"
      image={<Icon className="error-icon" name={IconName.ErrorState} />}
      isAgent={isAgentPortal}
      isMobile={matchesMobile}
      open={isOpen}
      subtitle={textConstants.AVAILABILITY_ERROR_SUBTITLE}
      title={textConstants.AVAILABILITY_ERROR_TITLE}
    />
  );
};
